<soft-ds-card class="h-full min-h-[30vh]">
  <soft-ds-card-header>
    <soft-ds-card-leading
      variant="tinted"
      [tone]="kreditlimitUeberschritten() ? 'danger' : 'brand'"
    >
      <soft-ds-icon name="fa-regular fa-credit-card" />
    </soft-ds-card-leading>
    <soft-ds-card-title>Kreditlimit</soft-ds-card-title>
    @if (data()) {
      <soft-ds-card-description>
        {{ kreditlimitUeberschritten() ? 'Limit überschritten' : 'Im Rahmen' }}
      </soft-ds-card-description>
    }
  </soft-ds-card-header>

  <soft-ds-card-body class="flex flex-1 flex-col">
    @if (error(); as error) {
      <soft-ds-empty-state
        class="flex-1"
        variant="error"
        size="sm"
        [icon]="error.icon ?? null"
        [title]="error.subject ? (error.subject | translate) : null"
        [description]="(error.message | translate | interpolate: error.data) ?? null"
        data-testid="kreditlimit-widget-error"
      />
    } @else if (loading()) {
      <soft-ds-loading-skeleton width="100%" height="5rem" />
    } @else if (!data()) {
      <soft-ds-empty-state
        class="flex-1"
        size="sm"
        icon="fa-regular fa-credit-card"
        title="Keine Kreditlimitdaten vorhanden"
        data-testid="kreditlimit-widget-empty"
      />
    } @else if (kreditdaten$ | async; as data) {
      <div class="flex items-end justify-between gap-1">
        <p class="flex font-bold text-2xl "
        [ngClass]="[data.saldoGesamt > data.kreditlimit2 ? 'text-danger-600' : 'text-success-700']">{{ (data.saldoGesamt) | currency:'EUR' }}</p>
        <span class="text-sm text-light">{{ data.kreditlimit2 | currency:'EUR' }}</span>
      </div>

      <div class="flex flex-col mt-2">
        @if (gesamtKreditlimitTranslateX$ | async; as offset) {
          <div
            class="flex w-full rounded-full border border-solid border-surface h-4 limit-gradient overflow-hidden whitespace-nowrap"
            [ngClass]="[data.saldoGesamt > data.kreditlimit2 ? 'limit-gradient' : 'limit-gradient-success']"
            >
            <div [@animateIn2]="{ value: '*', params: { offset: offset } }" class="bg-surface-tertiary w-full h-full will-change-transform" [style.transform]="offset">&nbsp;</div>
          </div>
        }
        <span class="text-light mt-2 font-normal italic">{{ (data.saldoGesamt > data.kreditlimit2 ? (data.kreditlimit2 - data.saldoGesamt) * -1 : (data.kreditlimit2 - data.saldoGesamt)) | currency:'EUR' }} {{ data.saldoGesamt > data.kreditlimit2 ? 'überzogen' : 'verfügbar' }}</span>
      </div>
    }
  </soft-ds-card-body>
</soft-ds-card>
